// The family's on/off switch in the families table (and mobile card), saved on
// toggle. Off only hides the family and its variants from the app Marketplace.
import { MasterProductFamily, useUpdateMasterProductFamilyApi } from 'apis/master-product-families';
import { Switch, useToast } from 'design-system';

export interface IFamilyActiveCell {
  family: MasterProductFamily;
}

export const FamilyActiveCell = ({ family }: IFamilyActiveCell) => {
  const toast = useToast();
  const { mutate: updateFamily, isLoading } = useUpdateMasterProductFamilyApi({
    onSuccess: (data) => {
      toast({
        title:
          data.isActive === false
            ? `"${data.universalName}" hidden from the Marketplace`
            : `"${data.universalName}" shown in the Marketplace`,
        status: 'success',
      });
    },
    onError: (error: any) => {
      toast({
        title: error?.response?.data?.message || 'Failed to update family. Please try again.',
        status: 'error',
      });
    },
  });

  return (
    <Switch
      size='sm'
      aria-label={`Active: ${family.universalName}`}
      // A family read before the column existed has no isActive: it is on.
      isChecked={family.isActive !== false}
      isDisabled={isLoading}
      onChange={(e) => updateFamily({ id: family.id, data: { isActive: e.target.checked } })}
    />
  );
};
